export default __webpack_public_path__ + "static/media/modesp02.3fdec0d9.png";